import {
  ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS,
  ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS_SUCCESS,
  ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { track } from '../../analytics/analytics';

import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export type datatype = {
  organizationId?: string;
  settingId?: string;
  enabled?: any;
  product: string;
};

export function putOrganizationsProductsSettings(data: datatype) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/settings/products/${data.product}`,
        method: 'PUT',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { updateFeatureSuccess: true },
              'success',
            );
            dispatch(requestSuccess(response));
            handleTrack(data);
          }
        },
        fail: (error: any) => {
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { updateFeatureError: true },
                'error',
              );
          dispatch(requestFailed(error));
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_ORGANIZATIONS_PRODUCTS_SETTINGS_FAILURE,
    payload: responseJSON,
  };
}

function handleTrack(data: any) {
  if (data.organizationId !== undefined) {
    let result = 'removed';

    if (data.enabled) {
      result = 'added';
    }

    let properties = {
      Company: data.organizationId,
      Modified: 'features',
      Feature: 'Expenses',
      Result: result,
    };

    track('BB_CompanyUpdated', properties);
  }
}
